
































































































































































































































































































































































































































































































































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import OrcamentoOnlineModel from "@/models/orcamento-auto-online/OrcamentoOnlineModel";
import { estadosList, EstadoModel } from "@/models/commons/EstadoModel";
import TipoPinturaVeiculoModel, { tiposPituraVeiculoList } from "@/models/orcamento-auto-online/TipoPinturaveiculo";
import FotoModel from "@/models/orcamento-auto-online/FotoModel";
import { orcamentoAutoOnlineService } from "@/service/orcamento-auto-online/OrcamentoAutoOnlineService";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { orcamentoAutoApi } from "@/api/OrcamentoAutoApi";
import { tiposFotosList } from "@/models/orcamento-auto-online/TipoFoto";
import orcamentoAutoModule from "@/store/orcamento-auto/OrcamentoAutoModule";
import AprovarModal from "./AprovarModal.vue";
import Oficina from "@/models/orcamento-auto-online/Oficina";
import ImgDialog from "@/components/modal/ImgDialog.vue";
import GsModalDialog from "@/components/modal/GsModalDialog.vue";
import axios from "axios";

@Component({
  components: {
    ValidationObserver,
    ValidationProvider,
    ImgDialog,
    GsModalDialog,
    AprovarModal
  },
})
export default class DetalhesOrcamento extends Vue {
  $refs!: {
    orcamentoOnlineObserver: InstanceType<typeof ValidationObserver>;
    aprovarVue: InstanceType<typeof AprovarModal>;
    recusarObserver: InstanceType<typeof ValidationObserver>;
    dadosCadastraisObserver: InstanceType<typeof ValidationObserver>;
  };
  detalheOrcamento = this.initializeDetalheOrcamento();

  tiposFoto = tiposFotosList;
  fotos: FotoModel[] = [];
  oficinas = [];
  oficina: Oficina = this.novaOficina();
  estados = estadosList;
  tiposPintura = tiposPituraVeiculoList;

  loading = false;
  readonly = true;
  exibirCamposEdicao = false;

  motivoRecusa?: string = "";
  recusaModal = false;
  aprovaModal = false;
  realizarEstorno = false;

  /* MODAL */
  showDialog = false;
  successDialog = false;
  dialogTitle = "";
  dialogMessage = "";
  dialogType = "success";

  /* IMG MODAL */
  showImgModal = false;
  srcImg = "";
  imgType = "";

  infoDialog = false;

  voltar() {
    this.$router.back();
  }

  mounted() {
    this.carregarDetalhe(Number(this.$route.params.id));
  }

  novaOficina() {
    return {
      CNPJ: "",
      DDD: "",
      cep: "",
      cidade: "",
      email: "",
      endereco: "",
      enderecoNr: "",
      nomeFantasia: "",
      oficinaCredenciamento: "",
      oficinaTipo: "",
      razaoSocial: "",
      responsavel: "",
      siglaEstado: "",
      telefone: "",
      bairro: "",
    };
  }

  initializeDetalheOrcamento() {
    return {
      id: 0,
      idCliente: 0,
      cliente: {
        nome: "",
        email: "",
        telefone: "",
        telefones: [{
          ddd: "",
          numero: ""
        }]
      },
      frota: false,
      numeroOrcamento: "",
      preco: "",
      precoConserto: "",
      valorTotalPago: "",
      idDadosPagamento: 0,
      descricao: "",
      cidade: "",
      observacao: "",
      status: "",
      estado: { sigla: "", nome: "" },
      veiculo: {
        modelo: "",
        marca: "",
        placa: "",
        cor: "",
        chassi: "",
        quilometragem: 0,
        tipoPintura: { name: "", descricao: "" },
        colisaoParteDianteira: false,
        disparoAirBag: false,
        blindado: false,
        fotos: [],
      },
      oficina: {
        email: "",
        nomeFantasia: "",
        nomeResponsavel: "",
        telefone: ""
      }
    };
  }

  carregarDetalhe(id: number) {
    orcamentoAutoOnlineService
      .obterOrcamentoPorID(id)
      .then((res: any) => {
        this.detalheOrcamento = {
          id: id,
          idCliente: res.idCliente,
          cliente: res.cliente,
          numeroOrcamento: res.numeroOrcamento,
          preco: `${parseFloat(res.preco).toFixed(2)}`,
          precoConserto: `${parseFloat(res.precoConserto).toFixed(2)}`,
          valorTotalPago: `${parseFloat(res.valorTotalPago).toFixed(2)}`,
          idDadosPagamento: res.idDadosPagamento,
          descricao: res.descricao,
          cidade: res.cidade,
          observacao: res.observacao,
          status: res.status,
          frota: res.frota,
          estado: estadosList.find(
            (estado) => estado.sigla == res.estado
          ) as EstadoModel,
          veiculo: {
            modelo: res.veiculo.modelo,
            marca: res.veiculo.marca,
            placa: res.veiculo.placa,
            cor: res.veiculo.cor,
            chassi: res.veiculo.chassi,
            quilometragem: res.veiculo.quilometragem,
            tipoPintura: tiposPituraVeiculoList.find(
              (tipo) => tipo.name == res.veiculo.tipoPintura
            ) as TipoPinturaVeiculoModel,
            colisaoParteDianteira: res.veiculo.colisaoParteDianteira,
            disparoAirBag: res.veiculo.disparoAirBag,
            blindado: res.veiculo.blindado,
            fotos: res.veiculo.fotos,
          },
          oficina: res.oficina,
        };

        this.detalheOrcamento.cliente.telefone = this.formatarTelefoneCliente(
            this.detalheOrcamento.cliente.telefones[0].ddd || '', this.detalheOrcamento.cliente.telefones[0].numero || ''
          );

        this.obterOficinas();
        this.loadImgs(this.detalheOrcamento.veiculo.fotos);
      })
      .catch((err) => {
        this.openDialog(false, err);
        this.detalheOrcamento = this.initializeDetalheOrcamento();
      });
  }

  formatarTelefoneCliente(ddd: string, phone: string) {
    const telefone = (ddd + phone).replace(/[^\d]/g, "");
    if (telefone.length > 10) {
      return telefone.replace(/(\d{2})(\d{1})(\d{4})(\d{4})/, "($1) $2 $3-$4");
    } else {
      return telefone.replace(/(\d{2})(\d{4})(\d{4})/, "($1) $2-$3");
    }
  }
  
  obterOficinas() {
    this.loading = true;
    orcamentoAutoOnlineService
      .obterOficinasComDistancia(
        this.detalheOrcamento.cidade || "",
        this.detalheOrcamento.estado?.sigla || "",
        this.detalheOrcamento.idCliente,
        this.detalheOrcamento.id
      )
      .then((res) => {
        this.oficinas = res;
        
        /*this.oficinas.sort((a: any, b: any) => {
          return a.razaoSocial < b.razaoSocial
            ? -1
            : a.razaoSocial > b.razaoSocial 
              ? 1
              : 0;
        });*/
        if (this.oficinas.length < 1) {
          this.openInfoDialog("Oficinas indisponíveis para a sua região!");
        }
      })
      .catch((err) => {
        orcamentoAutoModule.SET_MENSAGEM_OFICINA(
          `${err.message}. Por favor, tente novamente mais tarde`
        );
        if (this.$refs.aprovarVue) {
          this.$refs.aprovarVue.setOficinaError();
        }
      })
      .finally(() => {
        this.loading = false;
      });
  }

  private loadImgs(imgs: FotoModel[]): void {
    const total = (imgs.length - 1);
    const convertedImgs: FotoModel[] = [];

    imgs.forEach((file: FotoModel, i: number) => {
      const data: FotoModel = {
        tipo: file.tipo ?? '',
        nomeArquivo: file.nomeArquivo ?? '',
        tipoFoto: tiposFotosList.find(t => t.name == file.tipo)
      };
      this.loadImgBase64(data.nomeArquivo ?? '').then((base64) => {
        data.base64 = base64;
        convertedImgs.push(data);
        if (i == total) {
          this.fotos = convertedImgs;
        }
      });
    });


  }

  private loadImgBase64(imgName: string): Promise<string> {
    return orcamentoAutoOnlineService.obterFotoPorIdOrcamentoENomeArquivo(this.detalheOrcamento?.id, imgName)
      .then((resp) => {
        var reader = new FileReader();
        reader.readAsDataURL(resp);
        return new Promise(resolve => {
          reader.onloadend = function() {
            resolve(reader.result as string);
          }
        });
      })
  }

  @Watch("detalheOrcamento.veiculo.placa", { immediate: true })
  observarPlaca(val: string) {
    this.detalheOrcamento.veiculo.placa = this.detalheOrcamento.veiculo.placa.toUpperCase();
  }

  @Watch("detalheOrcamento", { immediate: true })
  observarDetalhe() {
    if (this.detalheOrcamento?.status == "RECUSADO") {
      this.readonly = false;
      this.exibirCamposEdicao = true;
    } else {
      this.readonly = true;
      this.exibirCamposEdicao = false;
    }
  }

  obterFotoVeiculo(nomeArquivo: string) {
    return (
      process.env.VUE_APP_ORCAMENTO_AUTO_ONLINE_API +
      `/orcamentos/${this.detalheOrcamento?.id}/veiculo/foto/${nomeArquivo}`
    );
  }

  abrirModalAprovar() {
    this.aprovaModal = true;
    // this.obterOficinas();
  }

  aprovar() {
    this.$refs.aprovarVue.validar().then((valid) => {
      if (valid) {
        this.loading = true;
        orcamentoAutoOnlineService
          .aprovar(
            this.detalheOrcamento.id,
            this.detalheOrcamento.veiculo,
            this.oficina
          )
          .then((res) => {
            this.oficina = this.novaOficina();
            this.openDialog(true, "Solicitação de orçamento aprovada!");
            this.loading = false;
            this.fecharModalAprovar();
          })
          .catch((err) => {
            this.openDialog(false, err);
            this.loading = false;
            this.oficina = this.novaOficina();
            this.fecharModalAprovar();
          });
      }
    });
  }

  cancelarAprovacao() {
    this.fecharModalAprovar();
    this.oficina = this.novaOficina();
  }

  fecharModalAprovar() {
    this.aprovaModal = false;
  }

  exibirBotaoGravar(status: string) { // botao responsavel por alterar os dados do cliente e veiculos
    if (status == "SOLICITADO" || status == "AGUARDANDO" || status == "AGUARDANDO_PENDENCIAS_CLIENTE") {
      return true;
    }
  }

  exiberBotaoRecusa(status: string) {
    if (status == "SOLICITADO" || status == "AGUARDANDO") {
      return true;
    }
  }

  abrirModalRecusa() {
    this.recusaModal = true;
    this.motivoRecusa = undefined;
  }

  alterarDados() {
    this.$refs.dadosCadastraisObserver.validate().then((valid) => {
      if (valid) {

        let informacoesCadastrais = {
          nome: this.detalheOrcamento.cliente.nome,
          email: this.detalheOrcamento.cliente.email,
          telefone: this.detalheOrcamento.cliente.telefone,
          placa: this.detalheOrcamento.veiculo.placa,
        };

        orcamentoAutoOnlineService
          .atualizarInformacoesCadastrais(this.detalheOrcamento.id, informacoesCadastrais)
          .then((res) => {
            this.openDialog(true, "Dados alterados com sucesso!");
          })
          .catch((err) => {
            this.openDialog(false, err);
          });
      } else {
        setTimeout(() => {
          const errors = Object.entries(this.$refs.dadosCadastraisObserver.errors)
            .map(([key, value]) => ({ key, value }))
            .filter((error) => error["value"].length);
          this.$refs.dadosCadastraisObserver.refs[
            errors[0]["key"]
          ].$el.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
        }, 100);
      }
    });
  }

  recusar() {
    this.$refs.recusarObserver.validate().then((valid) => {
      if (valid) {
        orcamentoAutoOnlineService
          .recusarOrcamento(this.detalheOrcamento.id, this.motivoRecusa, this.realizarEstorno)
          .then((res) => {
            this.fecharModalRecusa();
            this.openDialog(true, "Orçamento recusado.");
            this.motivoRecusa = undefined;
          })
          .catch((err) => {
            this.fecharModalRecusa();
            this.openDialog(false, err);
            this.oficina = this.novaOficina();
          });
      }
    });
  }

  cancelarRecusa() {
    this.fecharModalRecusa();
    this.oficina = this.novaOficina();
    this.motivoRecusa = undefined;
  }

  fecharModalRecusa() {
    this.recusaModal = false;
    this.motivoRecusa = undefined;
    this.$refs.recusarObserver.reset();
  }

  closeDialog() {
    this.showDialog = false;
    this.infoDialog = false;
    if (this.successDialog) {
      this.$router.replace({ name: "OrcamentosSolicitados" });
    }
  }

  openDialog(success: boolean, msg: string) {
    this.loading = false;
    this.successDialog = success;
    this.dialogTitle = success ? "Sucesso" : "Erro";
    this.dialogType = success ? "success" : "error";
    this.dialogMessage = msg;
    this.showDialog = true;
  }

  openInfoDialog(msg: string) {
    this.dialogType = "info";
    this.dialogTitle = "ATENÇÃO !";
    this.loading = false;
    this.dialogMessage = msg;
    this.infoDialog = true;
  }

  get btnColor() {
    switch (this.dialogType) {
      case "success":
        return "#00CD96";
      case "error":
        return "error";
      case "confirm":
        return "warning";
      default:
        return "primary";
    }
  }

  get btnText() {
    return this.successDialog ? "Ok, entendi" : "Fechar";
  }

  get dialogImg() {
    return `${this.dialogType}.png`;
  }

  openImgModal(imgName: string, imgType: string) {
    orcamentoAutoOnlineService.obterFotoPorIdOrcamentoENomeArquivo(this.detalheOrcamento?.id, imgName)
      .then((resp) => {
        var reader = new FileReader();
        reader.readAsDataURL(resp);
        new Promise(resolve => {
          reader.onloadend = function() {
            resolve(reader.result);
          }
        }).then(res => {
          this.srcImg = res as string;
          this.imgType = imgType;
          this.showImgModal = true;
        });
      })
  }

  closeImgModal(): void {
    this.showImgModal = false;
  }

  downloadImg() {
    axios({
      url: this.srcImg,
      method: 'GET',
      responseType: 'blob'
    })
    .then((resp) => {
      var fileURL = window.URL.createObjectURL(new Blob([resp.data]));
      var fileLink = document.createElement('a');

      fileLink.href = fileURL;
      fileLink.setAttribute('download', `${this.imgType}.jpg`);
      document.body.appendChild(fileLink);

      fileLink.click();
    });
  }
}
